const intlCache: Record<string, Intl.DateTimeFormat> = {};

export function formatDateRange(
  earliestDate: Date | string,
  latestDate: Date | string,
  locale = 'en-GB',
  {
    month = 'short',
    includeYear = true,
    timezone,
  }: { month?: string; includeYear?: boolean; timezone?: string } = {}
) {
  const key = `${locale},${timezone},${month}`;
  let formatter = intlCache[key];

  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: month as any,
      year: 'numeric',
      timeZone: timezone,
    });
    intlCache[key] = formatter;
  }

  const result = formatter.formatRange(
    new Date(earliestDate),
    new Date(latestDate)
  );
  if (includeYear) {
    return result;
  }
  return result.replace(/(,\s)?20\d\d/g, '').trim();
}
